import {request} from "../request/request";

const personalData = {
  putMyOne: (data) => request.update(`/personal-data`, data, true),
  putOne: (userId, data) => request.update(`/personal-data/${userId}`, data, true),
};

export {personalData};